var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bar-chart',{attrs:{"title":_vm.title,"colors":_vm.colors,"series":_vm.series,"labels":_vm.labels,"loading":_vm.loading,"datalabels":false,"yAxis":_vm.yAxis,"formatter":_vm.formatter,"outlined":true,"dags":_vm.useMarmitonFilters
      ? [
          'get_and_store_posts_marmiton_ga_daily_dag',
          'adn_daily_posts_sites_infos_dag' ]
      : ['ga_get_and_store_site_daily_dag', 'adn_daily_posts_sites_infos_dag'],"useMarmitonFilters":""}})}
var staticRenderFns = []

export { render, staticRenderFns }